import { InstanceScreen } from 'component/navigation/instance';

export default function SpaceModerationDetailsScreen() {
    return <InstanceScreen screenKey='moderationDetails' />;
}
